<template>
  <b-container v-if="this.$root.signedIn">
    <br>
    <b-row v-show="!this.loading">
      <b-col>
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-btn block href="#" v-b-toggle.accordion1 variant="primary">
              Search Criteria
              <font-awesome-icon icon="caret-down" size="lg" v-if="!showCriteria"/> 
              <font-awesome-icon icon="caret-up" size="lg" v-if="showCriteria"/>
            </b-btn>
          </b-card-header>
          <b-collapse id="accordion1" visible accordion="accordion1" role="tabpanel" v-model="showCriteria">
            <b-card-body>
              <b-container>
                <b-row>
                  <b-col>
                    <h3>Compare</h3>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Programme(s)</b-col>
                      <b-col>
                        <multiselect v-model="programmes1" :options="programmeList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Year(s)</b-col>
                      <b-col>
                        <multiselect v-model="years1" :options="yearsList" :multiple="true" :close-on-select="false" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Industry(s)</b-col>
                      <b-col>
                        <multiselect v-model="industries1" :options="industryList" :multiple="true" :close-on-select="false" :placeholder="'All'" :select-label="''" :deselect-label="''"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Customer(s)</b-col>
                      <b-col>
                        <multiselect v-model="customers1" :options="customerList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Country(s)</b-col>
                      <b-col>
                        <multiselect v-model="countries1" :options="countryList" :multiple="true" :close-on-select="false" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Region(s)</b-col>
                      <b-col>
                        <multiselect v-model="regions1" :options="regionList1" :multiple="true" :close-on-select="false" :placeholder="'All'" group-values="regions" group-label="country" :group-select="true"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Labelled As</b-col>
                      <b-col>
                        <b-form-input v-model="label1" type="text" placeholder="Dataset 1"/>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col>
                    <h3>With</h3>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Programme(s)</b-col>
                      <b-col>
                        <multiselect v-model="programmes2" :options="programmeList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Year(s)</b-col>
                      <b-col>
                        <multiselect v-model="years2" :options="yearsList" :multiple="true" :close-on-select="false" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Industry(s)</b-col>
                      <b-col>
                        <multiselect v-model="industries2" :options="industryList" :multiple="true" :close-on-select="false" :placeholder="'All'" :select-label="''" :deselect-label="''"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Customer(s)</b-col>
                      <b-col>
                        <multiselect v-model="customers2" :options="customerList" :multiple="true" :close-on-select="false" track-by="id" label="name" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Country(s)</b-col>
                      <b-col>
                        <multiselect v-model="countries2" :options="countryList" :multiple="true" :close-on-select="false" :placeholder="'All'"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Region(s)</b-col>
                      <b-col>
                        <multiselect v-model="regions2" :options="regionList2" :multiple="true" :close-on-select="false" :placeholder="'All'" group-values="regions" group-label="country" :group-select="true"/>
                      </b-col>
                    </b-row>
                    <b-row class="pb-2">
                      <b-col class="text-left text-nowrap" cols=3>Labelled As</b-col>
                      <b-col>
                        <b-form-input v-model="label2" type="text" placeholder="Dataset 2"/>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="pt-3" v-show="!this.loading">
      <b-col class="text-left align-left">
        <toggle-button id="gears-or-scores" v-model="showGears" :labels="{checked: 'Gears', unchecked: 'Average Scores'}" :width="200" :height="40" :switch-color="{checked: '#0069D9', unchecked: '#218838'}" :color="{checked: '#278fff', unchecked: '#30c651'}"/>
      </b-col>
      <b-col class="text-right align-right">
        <b-btn variant="primary" @click="calculateData()">Compare</b-btn>
      </b-col>
    </b-row>
    <b-row class="pt-4 pb-4" v-show="chartData && !loadingData">
      <b-col class="text-center align-center mx-auto">
        <score-gear-year-line v-if="chartData" :chart-data="chartData" :width="1000" :show-gears="showGears" :label1="label1" :label2="label2"/>
      </b-col>
    </b-row>
    <b-row v-show="loading" align-h="center" class="text-center align-center">
      <b-col cols=1>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
    <b-row v-show="loadingData" align-h="center" class="text-center align-center mx-auto">
      <b-col cols=1>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// @ is an alias to /src
import CustomerSelection from "@/components/CustomerSelection.vue";
import Datepicker from 'vuejs-datepicker';
import {industries, countries, regions} from '@/services/constants';
import VueTagsInput from '@johmun/vue-tags-input';
import * as _ from 'lodash';
import * as API from '@/services/API';
import * as Reporting from '@/services/Reporting';
import { Printd } from 'printd';
import vueConfirmationButton from 'vue-confirmation-button';
import ToggleButton from 'vue-js-toggle-button/src/Button';
import ScoreGearYearLine from '@/graphs/ScoreGearYearLine';

export default {
  name: "GPCSearch",
  components: {
    CustomerSelection,
    Datepicker,
    VueTagsInput,
    vueConfirmationButton,
    ToggleButton,
    ScoreGearYearLine
  },
  computed: {
    
  },
  watch: {
    countries1: function(val) {
      this.regionList1 = this.getRegions(val);
    },
    countries2: function(val) {
      this.regionList2 = this.getRegions(val);
    }
  },
  created () {
    this.init();
  },
  data: function() {
    return {
      customerList: [],
      industryList: industries,
      programmeList: [],
      countryList: countries,
      regionList1: [],
      regionList2: [],
      customers1: [],
      industries1: [],
      programmes1: [],
      countries1: [],
      regions1: [],
      customers2: [],
      industries2: [],
      programmes2: [],
      countries2: [],
      regions2: [],
      years1: [],
      years2: [],
      yearsList: [],
      label1: 'Dataset 1',
      label2: 'Dataset 2',
      showGears: false,
      chartData: null,
      showCriteria: true,
      loading: true,
      loadingData: false
    }
  },
  methods: {
    init() {
      this.regionList1 = this.getRegions(null);
      this.regionList2 = this.getRegions(null);
      this.loading = true;
      const thisYear = new Date().getFullYear();
      this.yearsList = [];
      for (let i = thisYear; i >= 2011; i-=1 ) {
        this.yearsList.push(i);
      }
      return Promise.all([
        API.getCustomers().then(results => this.customerList = results.results),
        API.getProgrammes().then(results => this.programmeList = results.results)
      ]).then(() => { this.loading = false; });
      
    },
    getRegions(countries) {
      return Object.keys(regions).map((country) => {
        return {
          country,
          regions: regions[country]
        };
      }).filter(x => (!countries || countries.length === 0 || countries.indexOf(x.country) != -1))
    },
    calculateData() {
      this.showCriteria = false;
      this.loadingData = true;

      // make queries
      const query1 = {};
      if (this.customers1 && this.customers1.length > 0) query1.customer_id = this.customers1.map(customer => customer.id);
      if (this.regions1 && this.regions1.length > 0) query1["customer_id:Customer.region"] = this.regions1;
      if (this.programmes1 && this.programmes1.length > 0) query1.programme_id = this.programmes1.map(programme => programme.id);
      if (this.countries1 && this.countries1.length > 0) query1["customer_id:Customer.country"] = this.countries1;
      if (this.industries1 && this.industries1.length > 0) query1["customer_id:Customer.industry"] = this.industries1;
      if (this.years1 && this.years1.length > 0) query1['year'] = this.years1;
      const query2 = {};
      if (this.customers2 && this.customers2.length > 0) query2.customer_id = this.customers2.map(customer => customer.id);
      if (this.regions2 && this.regions2.length > 0) query2["customer_id:Customer.region"] = this.regions2;
      if (this.programmes2 && this.programmes2.length > 0) query2.programme_id = this.programmes2.map(programme => programme.id);
      if (this.countries2 && this.countries2.length > 0) query2["customer_id:Customer.country"] = this.countries2;
      if (this.industries2 && this.industries2.length > 0) query2["customer_id:Customer.industry"] = this.industries2;
      if (this.years2 && this.years2.length > 0) query2['year'] = this.years2;
      // get
      return Promise.all([
        Reporting.getScores({where: query1, groupBy: ['year']}),
        Reporting.getScores({where: query2, groupBy: ['year']})
      ]).then(results => {
        // mash
        const newData = {};
        results[0].forEach(dataPoint => newData[dataPoint.year] = [dataPoint]);
        results[1].forEach(dataPoint => {
          if (!newData[dataPoint.year]) newData[dataPoint.year] = [null];
          newData[dataPoint.year].push(dataPoint);
        });
        this.chartData = Object.values(newData).sort((a, b) => (a[0] || a[1]).year - (b[0] || b[1]).year);
        this.loadingData = false;
      });
    }
  }
}
</script>
<style>
.vue-js-switch#gears-or-scores {
  font-size: 16px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/IndustryScoreGearLines.vue